import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "l-search" };
const _hoisted_2 = { class: "l-content" };
const _hoisted_3 = { class: "text-center text-white mb-0" };
const _hoisted_4 = { class: "l-content" };
const _hoisted_5 = { class: "table-responsive" };
const _hoisted_6 = { class: "text-nowrap" };
const _hoisted_7 = { class: "text-nowrap" };
const _hoisted_8 = {
    key: 0,
    class: "small fa-solid fa-sort-up text-secondary up"
};
const _hoisted_9 = {
    key: 1,
    class: "small fa-solid fa-sort-down text-secondary down"
};
const _hoisted_10 = { class: "text-nowrap" };
const _hoisted_11 = {
    key: 0,
    class: "small fa-solid fa-sort-up text-secondary up"
};
const _hoisted_12 = {
    key: 1,
    class: "small fa-solid fa-sort-down text-secondary down"
};
const _hoisted_13 = { class: "text-nowrap" };
const _hoisted_14 = {
    key: 0,
    class: "small fa-solid fa-sort-up text-secondary up"
};
const _hoisted_15 = {
    key: 1,
    class: "small fa-solid fa-sort-down text-secondary down"
};
const _hoisted_16 = { key: 0 };
const _hoisted_17 = { class: "l-item" };
const _hoisted_18 = { class: "position-relative" };
const _hoisted_19 = ["src", "alt"];
const _hoisted_20 = ["href"];
const _hoisted_21 = { class: "text-white align-middle position-relative" };
const _hoisted_22 = ["href"];
const _hoisted_23 = { class: "text-white align-middle position-relative" };
const _hoisted_24 = ["href"];
const _hoisted_25 = { class: "text-white align-middle position-relative" };
const _hoisted_26 = ["href"];
const _hoisted_27 = {
    key: 1,
    class: "text-center"
};
const _hoisted_28 = {
    key: 0,
    class: "d-flex justify-content-center"
};
import VuePagination from '@asika32764/vue-pagination';
import { useDebounceFn } from '@vueuse/core';
import { onMounted, ref, watch } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SearchContent',
    props: {
        type: {},
        q: {},
        page: {},
        order: {},
        dir: {}
    },
    setup(__props) {
        const props = __props;
        const loading = ref(false);
        const root = ref();
        const items = ref();
        const pagination = ref(0);
        const total = ref(0);
        const currentPage = ref(1);
        const order = ref(props.order);
        const dir = ref(props.dir);
        onMounted(async () => {
            await loadItems();
            if (props.page !== 1) {
                await pageChange(props.page);
            }
        });
        const loadItemsDebounced = useDebounceFn(async () => {
            await loadItems();
        }, 800);
        watch(() => [props.q, props.type], async () => {
            currentPage.value = 1;
            await loadItemsDebounced();
        });
        async function loadItems() {
            await updateUrl();
            await fetchItems();
        }
        async function fetchItems() {
            let entry = '';
            try {
                loading.value = true;
                const res = await u.$http.get(`@protocol_ajax/search`, {
                    params: {
                        type: props.type,
                        q: props.q,
                        page: currentPage.value,
                        order: order.value,
                        dir: dir.value
                    }
                });
                items.value = res.data.data.items;
                pagination.value = res.data.data.pagination;
                total.value = res.data.data.total;
            }
            catch (e) {
                console.error(e);
                swal(e.message, '', 'warning');
            }
            finally {
                loading.value = false;
            }
        }
        async function updateUrl() {
            const url = new URL(location.href);
            url.searchParams.set('type', props.type);
            url.searchParams.set('q', props.q);
            url.searchParams.set('page', currentPage.value.toString());
            url.searchParams.set('order', order.value);
            url.searchParams.set('dir', dir.value);
            u.$router.push({
                state: {
                    type: props.type,
                    q: props.q,
                    page: currentPage.value,
                    order: order.value,
                    dir: dir.value,
                },
                uri: url.toString()
            });
        }
        async function pageChange(event) {
            window.scrollTo({
                top: root.value.getBoundingClientRect().x + 190,
                behavior: 'smooth'
            });
            currentPage.value = event;
            return loadItems();
        }
        async function sort(orderType) {
            dir.value = dir.value === 'ASC' ? 'DESC' : 'ASC';
            if (orderType !== order.value) {
                dir.value = 'ASC';
            }
            order.value = orderType;
            await pageChange(1);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.$lang('datavideo.protocol.list.search.title')), 1)
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("table", {
                            class: "table l-table",
                            id: "protocol-items",
                            ref_key: "root",
                            ref: root
                        }, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$lang('datavideo.protocol.list.label.image')), 1),
                                    _createElementVNode("th", _hoisted_7, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-outline-gray l-content__sort position-relative p-0",
                                            onClick: _cache[0] || (_cache[0] = ($event) => (sort('product.model')))
                                        }, [
                                            _createElementVNode("span", {
                                                class: _normalizeClass(["small mr-3", order.value === 'product.model' ? `text-secondary` : ''])
                                            }, _toDisplayString(_ctx.$lang('datavideo.protocol.list.label.model')), 3),
                                            _cache[4] || (_cache[4] = _createElementVNode("i", { class: "small fa-solid fa-sort" }, null, -1)),
                                            (order.value === 'product.model' && dir.value === `ASC`)
                                                ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                                                : _createCommentVNode("", true),
                                            (order.value === 'product.model' && dir.value === `DESC`)
                                                ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    _createElementVNode("th", _hoisted_10, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-outline-gray l-content__sort position-relative p-0",
                                            onClick: _cache[1] || (_cache[1] = ($event) => (sort('protocol.category_lang_title')))
                                        }, [
                                            _createElementVNode("span", {
                                                class: _normalizeClass(["small mr-3", order.value === 'protocol.category_lang_title' ? `text-secondary` : ''])
                                            }, _toDisplayString(_ctx.$lang('datavideo.protocol.list.label.protocol.category')), 3),
                                            _cache[5] || (_cache[5] = _createElementVNode("i", { class: "small fa-solid fa-sort" }, null, -1)),
                                            (order.value === 'protocol.category_lang_title' && dir.value === `ASC`)
                                                ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                                                : _createCommentVNode("", true),
                                            (order.value === 'protocol.category_lang_title' && dir.value === `DESC`)
                                                ? (_openBlock(), _createElementBlock("i", _hoisted_12))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    _createElementVNode("th", _hoisted_13, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-outline-gray l-content__sort position-relative p-0",
                                            onClick: _cache[2] || (_cache[2] = ($event) => (sort('category_lang.title')))
                                        }, [
                                            _createElementVNode("span", {
                                                class: _normalizeClass(["small mr-3", order.value === 'category_lang.title' ? `text-secondary` : ''])
                                            }, _toDisplayString(_ctx.$lang('datavideo.protocol.list.label.product.category')), 3),
                                            _cache[6] || (_cache[6] = _createElementVNode("i", { class: "small fa-solid fa-sort" }, null, -1)),
                                            (order.value === 'category_lang.title' && dir.value === `ASC`)
                                                ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                                                : _createCommentVNode("", true),
                                            (order.value === 'category_lang.title' && dir.value === `DESC`)
                                                ? (_openBlock(), _createElementBlock("i", _hoisted_15))
                                                : _createCommentVNode("", true)
                                        ])
                                    ])
                                ])
                            ]),
                            (!loading.value)
                                ? (_openBlock(), _createElementBlock("tbody", _hoisted_16, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
                                        return (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                                            _createElementVNode("td", _hoisted_18, [
                                                _createElementVNode("img", {
                                                    src: item.cover,
                                                    class: "l-item__img",
                                                    alt: item.title
                                                }, null, 8, _hoisted_19),
                                                _createElementVNode("a", {
                                                    href: item.url,
                                                    class: "stretched-link"
                                                }, _cache[7] || (_cache[7] = [
                                                    _createElementVNode("span", { class: "d-none" }, "Link", -1)
                                                ]), 8, _hoisted_20)
                                            ]),
                                            _createElementVNode("td", _hoisted_21, [
                                                _createElementVNode("div", null, _toDisplayString(item.model), 1),
                                                _createElementVNode("a", {
                                                    href: item.url,
                                                    class: "stretched-link"
                                                }, _cache[8] || (_cache[8] = [
                                                    _createElementVNode("span", { class: "d-none" }, "Link", -1)
                                                ]), 8, _hoisted_22)
                                            ]),
                                            _createElementVNode("td", _hoisted_23, [
                                                _createTextVNode(_toDisplayString(item.protocol_category_lang_title) + " ", 1),
                                                _createElementVNode("a", {
                                                    href: item.url,
                                                    class: "stretched-link"
                                                }, _cache[9] || (_cache[9] = [
                                                    _createElementVNode("span", { class: "d-none" }, "Link", -1)
                                                ]), 8, _hoisted_24)
                                            ]),
                                            _createElementVNode("td", _hoisted_25, [
                                                _createTextVNode(_toDisplayString(item.category_title) + " ", 1),
                                                _createElementVNode("a", {
                                                    href: item.url,
                                                    class: "stretched-link"
                                                }, _cache[10] || (_cache[10] = [
                                                    _createElementVNode("span", { class: "d-none" }, "Link", -1)
                                                ]), 8, _hoisted_26)
                                            ])
                                        ]));
                                    }), 256))
                                ]))
                                : (_openBlock(), _createElementBlock("tbody", _hoisted_27, _cache[11] || (_cache[11] = [
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("td", { colspan: "6" }, [
                                            _createElementVNode("div", {
                                                class: "spinner-border text-light",
                                                role: "status"
                                            }, [
                                                _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                                            ])
                                        ])
                                    ], -1)
                                ])))
                        ], 512),
                        (items.value?.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createVNode(_unref(VuePagination), {
                                    modelValue: currentPage.value,
                                    "onUpdate:modelValue": [
                                        _cache[3] || (_cache[3] = ($event) => ((currentPage).value = $event)),
                                        pageChange
                                    ],
                                    total: total.value,
                                    "per-page": 10,
                                    class: "pagination",
                                    "item-class": "page-item",
                                    "link-class": "page-link",
                                    "active-class": "active",
                                    "disabled-class": "disabled"
                                }, {
                                    "first-icon": _withCtx(() => _cache[12] || (_cache[12] = [
                                        _createTextVNode(" « ")
                                    ])),
                                    "previous-icon": _withCtx(() => _cache[13] || (_cache[13] = [
                                        _createTextVNode(" ‹ ")
                                    ])),
                                    "next-icon": _withCtx(() => _cache[14] || (_cache[14] = [
                                        _createTextVNode(" › ")
                                    ])),
                                    "last-icon": _withCtx(() => _cache[15] || (_cache[15] = [
                                        _createTextVNode(" » ")
                                    ])),
                                    _: 1
                                }, 8, ["modelValue", "total"])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]));
        };
    }
});
